/**
 * @implements iResource
 */
export default class UsersResource
{
	/**
	 * @property iResource|UsersResource
	 */
	#resource_adaptor
	#route_prefix = 'users/';
	#route_postfix = '';

	/**
	 *
	 * @param iResource|UsersResource resource_adaptor
	 */
	constructor(resource_adaptor)
	{
		this.#resource_adaptor = resource_adaptor
	}

	get()
	{
		return this.#resource_adaptor.get(`${this.#route_prefix}${this.#route_postfix}`)
	}

	show(id)
	{
		return this.#resource_adaptor.get(`${this.#route_prefix}${this.#route_postfix}${id}`)
	}
	getPermissions()
	{
		return this.#resource_adaptor.get(`${this.#route_prefix}permissions`)
	}
	getNested(parent_id)
	{
		return this.#resource_adaptor.get(`${this.#route_prefix}${parent_id}/${this.#route_postfix}`)
	}

	post(data)
	{
		return this.put(data);
	}

	put(data)
	{
		return this.#resource_adaptor.put(`${this.#route_prefix}${data.parent_id}/${this.#route_postfix}`, data)
	}
	putNested(parent_id, data)
	{
		return this.#resource_adaptor.put(`${this.#route_prefix}${parent_id}/${this.#route_postfix}`, data)
	}

	patch(id, data)
	{
		return this.#resource_adaptor.patch(`${this.#route_prefix}${this.#route_postfix}${id}`, data)
	}
	delete(id)
	{
		return this.#resource_adaptor.delete(`${this.#route_prefix}${this.#route_postfix}${id}`)
	}

}